import React from 'react'



import Header from './Header'
import Footer from './Footer'
import '../styles/global.css'
// import { Helmet } from 'react-helmet';
import ProgressArrow from './ProgressArrow';



function Layout({ path, children })
{
  return (
    <div className={`relative ${path !== "/" && "bg-lightGrey"}`} >
      <div className="flex flex-col min-h-screen">
        <Header />
        <main className="w-full flex-grow px-4 md:px-8 bg-white max-w-8xl mx-auto">
          {children}
        </main>
        <Footer />
      </div>
      <ProgressArrow />
    </div>
  );
}

export default Layout;